






















































































import {Component, Prop, Vue} from "vue-property-decorator";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";
import Notifications from "@/state/Notifications";
import IndividualTaxationService from "@/services/request/IndividualTaxationService";
import AcceptConditionsPayload from "@/dto/request/itrq/AcceptConditionsPayload";
import {processError} from "@/utils/ComponentUtils";


@Component({
  components: {
    PortalCheckbox
  }
})
export default class ITRQConsentsStep extends Vue {

  @Prop()
  id!: string;

  private payload = new AcceptConditionsPayload();

  private error: string | null = null;


  async submit() {
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      Notifications.warning(this.$t("auth.policy_acceptance.validation_error") as string);
      return;
    }
    this.$loadOn();
    IndividualTaxationService.acceptConditionsByPublicId(this.id, this.payload).then(
        ok => {
          this.$loadOff();
          this.$emit("submit");
        },
        err => processError(err, this)
    )
  }
}
